export default {
    DAIL_H : 16,
    AUDIO_STEP_H : 24,
    AUDIO_TRK_H : 24,
    AUDIO_SCROLLER_BAR_H : 12,
    AUDIO_SPLIT_LINE_H : 1
}


// WEBPACK FOOTER //
// ./src/common/scripts/pixi/AudioConst.js